import { useEffect, useRef, useState } from "react";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../assets/toastUtils";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Header/Header";
import NewSearchSateInput from "../../../NewSearchSateInput/NewSearchSateInput";
import Flatpickr from "react-flatpickr";
import styles from "./NewUiSearchFormHolidays.module.scss";
import NewUiHeader from "../../NewUIHeader/NewUIHeader";
import { SvgRightIcon, SvgSearch } from "../../../../utils/svgIcons";

import DatePicker from "react-datepicker";
import { format } from "date-fns";
import HomePageNewSearchSateInput from "../../../NewSearchSateInput/HomePageNewSearchSateInput";

function NewUiSearchFormHolidays({ topRadios }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [dataFromChild, setDataFromChild] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [show, setShow] = useState(false);
  const [showGuestDetailsPopup, setShowGuestDetailsPopup] = useState(false);
  // const [stateResultArray, setStateResultArray] = useState("");
  // console.log(stateResultArray);

  const getDataFromChild = (data, resultArray, selectedType) => {
    setDataFromChild(data);
    setSelectedType(selectedType);
    // setStateResultArray(resultArray)
  };

  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // console.log("isLoggedIn", isLoggedIn);

  const [guestDetails, setIsguestDetails] = useState(false);
  const [children, setChildren] = useState(0);
  const [childAge, setChildAge] = useState([]);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };
  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = children - 1;
    setChildren(updatedChildren);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = children + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectDates, setselectDates] = useState(false);

  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const location = useLocation();
  const navigate = useNavigate();

  // STATES
  // const [date, setDate] = useState(new Date());

  const [date, setDate] = useState(() => {
    const today = new Date();
    today.setDate(today.getDate() + 7);
    return today;
  });

  const [selectedRadio, setSelectedRadio] = useState("");

  const [data, setData] = useState({
    fromCity: "",
    toCity: "",
  });
  //
  const [guest, setGuest] = useState(2);

  // Date alterations
  const [loader, setLoader] = useState(false);

  // functions for increase decrease

  const handleSubmitButtonClickHandler = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);

    // console.log(children, "children");

    try {
      await navigate(
        `/listing-holidays?location=${dataFromChild}&guest=${guest}&children=${children}&${childAgeParams}&day=${date.getDate()}&month=${
          date.getMonth() + 1
        }&year=${date.getFullYear()}&radio=${selectedRadio}&selected_destinations=${dataFromChild}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandlerPackage = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);

    try {
      await navigate(
        `/package/${selectedType?.packagehandle}?packageId=${selectedType?.id}&location=${data.fromCity}&guest=${guest}&children=${children}&${childAgeParams}&selected_destinations=${data.fromCity}`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  // const handleSelectRoomClickHandler = async (item, hotelData, room_id) => {
  //   let hasChildAgeError = false;
  //   const childAge = bookingData?.childAge;
  //   const sanitizedChildAges = childAge
  //     .map((age) => (age !== "" ? age : null))
  //     .filter((age) => age !== null);

  //   const childAgeParams = sanitizedChildAges
  //     .map((age, index) => {
  //       if (age > 12) {
  //         alert("Child age must be between 0 and 12");
  //         hasChildAgeError = true;
  //         return;
  //       }
  //       return `&childAge[${index + 1}]=${age}`;
  //     })
  //     .join("");

  //   if (hasChildAgeError) {
  //     alert("Child age must be between 0 and 12");
  //     return;
  //   }

  //   // console.log(children, 'jjj');

  //   // Calculate booking values before navigating
  //   try {
  //     // http://localhost:3000/package/complete-himachal?location=shimla&guest=2&packagehandle=complete-himachal
  //     await navigate(
  //       `/package/${packagehandle}?location=${data.fromCity}&guest=${guest}&children=${children}&${childAgeParams}&packagehandle=${packagehandle}`,
  //       undefined,
  //       { shallow: false }
  //     );
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APP_URL}/api/v1/customers/logout`,
        requestOptions
      );
      const result = await response.text();
      // console.log(result);
      showSuccessToast("Logged Out Successfull");
      localStorage.clear();
      setIsLoggedIn(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (destinationToggle) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [destinationToggle]);

  const getFunctionRunHandler = (type) => {
    switch (type) {
      case "destination":
        return handleSubmitButtonClickHandler();
      case "package":
        return handleSubmitButtonClickHandlerPackage();
      default:
        // console.log("Invalid type");
        break;
    }
  };

  const availableAges = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  // Function to add a child's age
  const handleAddChildAge = (age) => {
    setChildAge((prevAges) => {
      const newAges = [...prevAges, age];
      setChildren(newAges.length);
      return newAges;
    });
    setShowGuestDetailsPopup(false);
  };

  // Function to remove a child's age
  const handleRemoveChild = (indexToRemove) => {
    setChildAge((prevAges) => {
      const newAges = prevAges.filter((_, index) => index !== indexToRemove);
      setChildren(newAges.length);
      return newAges;
    });
  };

  return (
    <>
      {/* <NewHeaderBg /> */}
      {/* <Header /> */}
      <NewUiHeader />

      {width <= 640 && (
        <div className={styles.NewUiSearchWrapperMobile}>
          <div
            className={styles.NewUiSearchParentMobile}
            onClick={() => {
              setShow((prev) => !prev);
              setIsguestDetails(false);
              setdestinationToggle(false);
            }}
          >
            <div>
              <SvgSearch />
            </div>

            <div>Where would you like to go ?</div>

            <div>
              <SvgRightIcon />
            </div>
          </div>

          {show && (
            <>
              <form
                className={styles.NewUiSearchWrapperFormMobile}
                onSubmit={
                  selectedType?.type === "package"
                    ? handleSubmitButtonClickHandlerPackage
                    : handleSubmitButtonClickHandler
                }
              >
                <div className={styles.widthOfDestination}>
                  <label htmlFor="">Destination/Package </label>
                  {/* <NewSearchSateInput
                    onClick={() => setdestinationToggle(true)}
                    onDataChange={getDataFromChild}
                    dropdownGuestDetails={dropdownGuestDetails}
                    setIsguestDetails={setIsguestDetails}
                    type="package"
                  /> */}
                  <HomePageNewSearchSateInput
                    onClick={() => setdestinationToggle(true)}
                    onDataChange={getDataFromChild}
                    dropdownGuestDetails={dropdownGuestDetails}
                    setIsguestDetails={setIsguestDetails}
                    type="package"
                  />
                </div>
                <div
                  className={`${styles.leftLineBorder} new_date_picker_react_js_custom_styling`}
                >
                  <label>Travel Date</label>

                  {/* <Flatpickr
                    className=""
                    color="#ffffff"
                    value={date}
                    onChange={([date]) => setDate(date)}
                    options={{
                      // minDate: todaysDate,
                      disableMobile: true,
                    }}
                  /> */}

                  <div className={styles.new_date_picker_wrapper}>
                    <DatePicker
                      selected={date}
                      onChange={(date) => setDate(date)}
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      dateFormat="dd MMM, yyyy"
                      placeholderText={
                        date ? format(date, "dd MMM, yyyy") : "Travel Date"
                      }
                    />
                  </div>
                </div>
                <div className={styles.leftLineBorder}>
                  <label
                    onClick={dropdownGuestDetails}
                    className="search_label"
                  >
                    Guests{" "}
                    <svg
                      width="9"
                      height="5"
                      viewBox="0 0 9 5"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.25 0.75L4.75 4.25L1.25 0.75"
                        stroke="#BB735D"
                      />
                    </svg>
                  </label>
                  <div
                    style={{ position: "relative" }}
                    className="dropdown-toggle search_form_input"
                    onClick={() => setdestinationToggle(true)}
                  >
                    <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                      <div className="optionCounter"></div>
                      <span id="adult_count" className="font_16">
                        {" "}
                        <b>{guest}</b>{" "}
                      </span>
                      <span className="font_12"> Guests, </span>
                      <span id="child_count" className="font_16">
                        <b>{children}</b>
                      </span>
                      <span className="font_12"> Children</span>
                    </div>
                    {guestDetails && (
                      <div
                        className="guest_details_dropdown"
                        id="guestDetailsPopup"
                      >
                        <div className="agent">
                          <span>Guests</span>
                          <div className="flex align_items_center">
                            <button
                              type="button"
                              disabled={guest <= 1}
                              className={`optionButton ${
                                guest <= 2 ? "disabled-button" : ""
                              }`}
                              onClick={() => {
                                if (guest <= 2) return;
                                setGuest(Number(guest) - 1);
                              }}
                            >
                              -
                            </button>

                            <input
                              className="optionCounterNumber"
                              value={guest}
                              min={1}
                              type="number"
                              // onChange={(e) => setGuest(e.target.value)}
                              onChange={(e) => {
                                let value = Number(e.target.value);
                                if (isNaN(value)) return;
                                setGuest(Math.min(11, Math.max(2, value)));
                              }}
                            />

                            <button
                              type="button"
                              disabled={guest >= 11}
                              className="optionButton"
                              onClick={() => {
                                if (guest >= 11) return;
                                setGuest(Number(guest) + 1);
                              }}
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div>
                          {childAge.map((age, index) => (
                            <div
                              className="agent flex items-center gap-2"
                              key={index}
                            >
                              <span>
                                Child{" "}
                                <small style={{ fontSize: "12px" }}>
                                  {" "}
                                  ({age} Yrs){" "}
                                </small>
                              </span>
                              <div
                                className="remove_svg"
                                onClick={() => handleRemoveChild(index)}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_6577_13294"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="18"
                                    height="18"
                                  >
                                    <rect width="18" height="18" />
                                  </mask>
                                  <g mask="url(#mask0_6577_13294)">
                                    <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          ))}

                          {/* Add a child button */}
                          <div className="relative">
                          <div
                            className="flex align_items_center justify_content_between border"
                            style={{
                              padding: "10px ",
                              marginBottom: "10px",
                              fontWeight: "400",
                            }}
                            onClick={() =>
                              setShowGuestDetailsPopup(!showGuestDetailsPopup)
                            }
                          >
                            Add a Child
                            <div>
                              <svg
                                width="12"
                                height="6"
                                viewBox="0 0 12 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                                  fill="#1C1B1F"
                                />
                              </svg>
                            </div>
                          </div>

                          {/* Child age selection popup */}
                          {showGuestDetailsPopup && (
                            <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                              {availableAges.map((age, i) => (
                                <div
                                  className="new-age-option"
                                  key={i}
                                  onClick={() => handleAddChildAge(age)}
                                  style={{ fontWeight: "400" }}
                                >
                                  {age} Years
                                </div>
                              ))}
                            </div>
                          )}</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <button type="submit" className={styles.submitButton}>
                  Search
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <mask
                        id="mask0_6818_5962"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="18"
                        height="18"
                      >
                        <rect width="18" height="18" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6818_5962)">
                        <path
                          d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                </button>
              </form>
              <button
                className={styles.MobileCloseBtn}
                onClick={() => {
                  setShow((prev) => !prev);
                  setIsguestDetails(false);
                  setdestinationToggle(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <mask
                    id="mask0_6577_14371"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="17"
                    height="17"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="16"
                      height="16"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6577_14371)">
                    <path
                      d="M4.76665 13.1666L3.83331 12.2333L7.56665 8.49992L3.83331 4.76659L4.76665 3.83325L8.49998 7.56659L12.2333 3.83325L13.1666 4.76659L9.43331 8.49992L13.1666 12.2333L12.2333 13.1666L8.49998 9.43325L4.76665 13.1666Z"
                      fill="#333333"
                    />
                  </g>
                </svg>
                Close
              </button>
            </>
          )}
        </div>
      )}

      <section
        onClick={() => setShow(false)}
        className={styles.NewUiSearchWrapper}
        id="home"
      >
        <div className={styles.NewUiSearchParent}>
          <h1 className="text-center">Find Your Himachal Escape Now</h1>
          <div
            className=""
            style={
              guestDetails || destinationToggle
                ? { zIndex: "999" }
                : { position: "" }
            }
          >
            {width > 640 && (
              <form
                className={styles.NewUiSearchFormWrapper}
                onSubmit={
                  selectedType?.type === "package"
                    ? handleSubmitButtonClickHandlerPackage
                    : handleSubmitButtonClickHandler
                }
              >
                <div className={styles.widthOfDestination}>
                  <label htmlFor="">Destination/Package</label>
                  <HomePageNewSearchSateInput
                    onClick={() => setdestinationToggle(true)}
                    onDataChange={getDataFromChild}
                    dropdownGuestDetails={dropdownGuestDetails}
                    setIsguestDetails={setIsguestDetails}
                    type="package"
                  />
                </div>
                <div
                  className={`${styles.leftLineBorder} new_date_picker_react_js_custom_styling`}
                >
                  <label>Travel Date</label>
                  {/* <Flatpickr
                    className=""
                    color="#ffffff"
                    value={date}
                    onChange={([date]) => setDate(date)}
                    min={new Date()}
                    f
                  /> */}
                  <div className={styles.new_date_picker_wrapper}>
                    <DatePicker
                      selected={date}
                      onChange={(date) => setDate(date)}
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      dateFormat="dd MMM, yyyy"
                      placeholderText={
                        date ? format(date, "dd MMM, yyyy") : "Travel Date"
                      }
                    />
                  </div>
                </div>
                <div className={styles.leftLineBorder}>
                  <label
                    onClick={dropdownGuestDetails}
                    className="search_label"
                  >
                    Guests{" "}
                    <svg
                      width="9"
                      height="5"
                      viewBox="0 0 9 5"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.25 0.75L4.75 4.25L1.25 0.75"
                        stroke="#BB735D"
                      />
                    </svg>
                  </label>
                  <div
                    style={{ position: "relative" }}
                    className="dropdown-toggle search_form_input"
                    onClick={() => setdestinationToggle(true)}
                  >
                    <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                      <div className="optionCounter"></div>
                      <span id="adult_count" className="font_16">
                        {" "}
                        <b>{guest}</b>{" "}
                      </span>
                      <span className="font_12"> Guests, </span>
                      <span id="child_count" className="font_16">
                        <b>{children}</b>
                      </span>
                      <span className="font_12"> Children</span>
                    </div>
                    {guestDetails && (
                      <div
                        className="guest_details_dropdown"
                        id="guestDetailsPopup"
                      >
                        <div className="agent">
                          <span>Guests</span>
                          <div className="flex align_items_center">
                            <button
                              type="button"
                              disabled={guest <= 1}
                              className={`optionButton ${
                                guest <= 2 ? "disabled-button" : ""
                              }`}
                              onClick={() => {
                                if (guest <= 2) return;
                                setGuest(Number(guest) - 1);
                              }}
                            >
                              -
                            </button>

                            <input
                              className="optionCounterNumber gueestInputNewUI"
                              value={guest}
                              min={1}
                              type="number"
                              // onChange={(e) => setGuest(e.target.value)}
                              onChange={(e) => {
                                let value = Number(e.target.value);
                                if (isNaN(value)) return;
                                setGuest(Math.min(11, Math.max(2, value)));
                              }}
                            />

                            <button
                              type="button"
                              disabled={guest >= 11}
                              className="optionCounterButton optionCounterButtonWithBorder"
                              onClick={() => {
                                if (guest >= 11) return;
                                setGuest(Number(guest) + 1);
                              }}
                            >
                              <span className="onclick_btn" id="adult_plus">
                                +
                              </span>
                            </button>
                          </div>
                        </div>

                        {/* {childAge.map((age, index) => (
                          <div className="navbar agent">
                            <div>
                              <span>Child Age</span>
                            </div>
                            <div>
                              <input
                                className="childAge_input"
                                type="number"
                                name="childAge[]"
                                min="1"
                                value={age}
                                onChange={(event) =>
                                  handleChildrenAgeChange(index, event)
                                }
                                required
                              />
                            </div>
                          </div>
                        ))} */}

                        <div>
                          {childAge.map((age, index) => (
                            <div
                              className="agent flex items-center gap-2"
                              key={index}
                            >
                              <span>
                                Child{" "}
                                <small style={{ fontSize: "12px" }}>
                                  {" "}
                                  ({age} Yrs){" "}
                                </small>
                              </span>
                              <div
                                className="remove_svg"
                                onClick={() => handleRemoveChild(index)}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_6577_13294"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="18"
                                    height="18"
                                  >
                                    <rect width="18" height="18" />
                                  </mask>
                                  <g mask="url(#mask0_6577_13294)">
                                    <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                                  </g>
                                </svg>
                              </div>
                            </div>
                          ))}

                          {/* Add a child button */}
                          <div className="relative">
                          <div
                            className="flex align_items_center justify_content_between border"
                            style={{
                              padding: "10px ",
                              marginBottom: "10px",
                              fontWeight: "400",
                            }}
                            onClick={() =>
                              setShowGuestDetailsPopup(!showGuestDetailsPopup)
                            }
                          >
                            Add a Child
                            <div>
                              <svg
                                width="12"
                                height="6"
                                viewBox="0 0 12 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                                  fill="#1C1B1F"
                                />
                              </svg>
                            </div>
                          </div>

                          {/* Child age selection popup */}
                          {showGuestDetailsPopup && (
                            <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                              {availableAges.map((age, i) => (
                                <div
                                  className="new-age-option"
                                  key={i}
                                  onClick={() => handleAddChildAge(age)}
                                  style={{ fontWeight: "400" }}
                                >
                                  {age} Years
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className={styles.searchButtonDiv}>
                  <button type="submit" className={styles.submitButton}>
                    Search
                    <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <mask
                        id="mask0_6818_5962"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="18"
                        height="18"
                      >
                        <rect width="18" height="18" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6818_5962)">
                        <path
                          d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                    </span>
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* {width <= 640 && (
        <form
          className={styles.NewUiSearchFormWrapper}
          onSubmit={
            selectedType?.type === "package"
              ? handleSubmitButtonClickHandlerPackage
              : handleSubmitButtonClickHandler
          }
        >
          <div className={styles.widthOfDestination}>
            <label htmlFor="">City/Destination/Package</label>
            <NewSearchSateInput
              onClick={() => setdestinationToggle(true)}
              onDataChange={getDataFromChild}
              dropdownGuestDetails={dropdownGuestDetails}
              setIsguestDetails={setIsguestDetails}
              type="package"
            />
          </div>
          <div className={styles.leftLineBorder}>
            <label>Travel Date</label>
            <Flatpickr
              className=""
              color="#ffffff"
              value={date}
              onChange={([date]) => setDate(date)}
              min={new Date()}
              f
            />
          </div>
          <div className={styles.leftLineBorder}>
            <label onClick={dropdownGuestDetails} className="search_label">
              Guests{" "}
              <svg
                width="9"
                height="5"
                viewBox="0 0 9 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8.25 0.75L4.75 4.25L1.25 0.75" stroke="#BB735D" />
              </svg>
            </label>
            <div
              style={{ position: "relative" }}
              className="dropdown-toggle search_form_input"
              onClick={() => setdestinationToggle(true)}
            >
              <div onClick={dropdownGuestDetails} ref={dropdownRef}>
                <div className="optionCounter"></div>
                <span id="adult_count" className="font_16">
                  {" "}
                  <b>{guest}</b>{" "}
                </span>
                <span className="font_12"> Guests, </span>
                <span id="child_count" className="font_16">
                  <b>{children}</b>
                </span>
                <span className="font_12"> Children</span>
              </div>
              {guestDetails && (
                <div className="guest_details_dropdown" id="guestDetailsPopup">
                  <div className="agent">
                    <span>Guests</span>
                    <div>
                      <button
                        type="button"
                        disabled={guest <= 1}
                        className="optionCounterButton optionCounterButtonWithBorder"
                        onClick={() => {
                          if (guest <= 2) return;
                          setGuest(Number(guest) - 1);
                        }}
                      >
                        <span className="onclick_btn" id="adult_minus">
                          -
                        </span>
                      </button>

                      <input
                        className="optionCounterNumber"
                        value={guest}
                        min={1}
                        type="number"
                        onChange={(e) => setGuest(e.target.value)}
                      />

                      <button
                        type="button"
                        disabled={guest >= 11}
                        className="optionCounterButton optionCounterButtonWithBorder"
                        onClick={() => {
                          if (guest >= 11) return;
                          setGuest(Number(guest) + 1);
                        }}
                      >
                        <span className="onclick_btn" id="adult_plus">
                          +
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="agent">
                    <span>Children</span>
                    <div>
                      <button
                        type="button"
                        disabled={children <= 0}
                        className="optionCounterButton optionCounterButtonWithBorder"
                        onClick={onChildDecrease}
                      >
                        <span className="onclick_btn" id="adult_minus">
                          -
                        </span>
                      </button>

                      <input
                        className="optionCounterNumber"
                        value={children}
                        min={1}
                      />

                      <button
                        type="button"
                        // disabled={children <= 1}
                        className="optionCounterButton optionCounterButtonWithBorder"
                        onClick={onChildIncrease}
                      >
                        <span className="onclick_btn" id="adult_plus">
                          +
                        </span>
                      </button>
                    </div>
                  </div>

                  {childAge.map((age, index) => (
                    <div className="navbar agent">
                      <div>
                        <span>Child Age</span>
                      </div>
                      <div>
                        <input
                          className="childAge_input"
                          type="number"
                          name="childAge[]"
                          min="1"
                          value={age}
                          onChange={(event) =>
                            handleChildrenAgeChange(index, event)
                          }
                          required
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="">
            <button type="submit" className={styles.submitButton}>
              SEARCH
              <span>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="12"
                  viewBox="0 0 17 12"
                  fill="none"
                >
                  <g clipPath="url(#clip0_6093_5578)">
                    <path
                      d="M16.5488 5.27416C12.5086 4.76301 11.0605 0.540892 11.0395 0.5L10.0426 0.816914C10.0951 0.980483 11.1235 3.97584 13.9253 5.48885H0V6.51115H13.9253C11.134 8.02416 10.0951 11.0297 10.0426 11.1831L11.0395 11.5C11.0395 11.5 12.5086 7.23699 16.5488 6.72584L17.0105 6.6645V5.32528L16.5488 5.26394V5.27416Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6093_5578">
                      <rect
                        width="17"
                        height="11"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </button>
          </div>
        </form>
      )} */}

      {(guestDetails || destinationToggle || selectDates) && (
        <div
          onClick={() => [
            setIsguestDetails(false),
            setdestinationToggle(false),
            setselectDates(false),
          ]}
          className="ScreenDimmer"
        ></div>
      )}
    </>
  );
}

export default NewUiSearchFormHolidays;
